export default "__VITE_ASSET__BtliojW1__"